import { API_URLS } from "service/url";
import { normalizeApiError } from "../../../utils/normalizeApiError";
import axiosInstance from "../../axiosInstance";
import { ProjectDefaults } from "types/project/projectDefaults";


export const getProjectDefaults = async (
  projectUuid: string
): Promise<ProjectDefaults> => {
  try {
    const { data } = await axiosInstance.get<{ response: ProjectDefaults }>(
      `${API_URLS.PROJECT_WORK_DEFAULTS}/${projectUuid}`
    );

    return data.response;
  } catch (error) {
    throw normalizeApiError(error);
  }
};
